// @ts-check

import {useQuery} from "../../@reditor/frameworks/react-query"

import {keys} from "./keys"
import {getGlobal} from "./request"

/**
 * @template {Error} TError
 * @template [TData=import('./types').GetGlobalResult]
 * @param {import('../../@reditor/frameworks/react-query').UseQueryOptions<
 *  import('./types').GetGlobalResult,
 *  TError,
 *  TData,
 *  ReturnType<typeof keys.singles>,
 * >=} options
 */
export function useGlobal(options = {}) {
  return useQuery(keys.singles, getGlobal, {
    refetchOnMount: false,
    cacheTime: Infinity,
    ...options,
  })
}
